import type { OrchestrationCommand, ThreadId } from "@taskin-code/contracts";
import { useNavigate } from "@tanstack/react-router";

/** Keeps the route guard ahead of projection delivery for every explicit thread creation. */
export async function openThreadAndDispatchCreate(input: {
  readonly threadId: ThreadId;
  readonly navigate: ReturnType<typeof useNavigate>;
  readonly openChatThreadPage: (threadId: ThreadId) => void;
  readonly dispatch: (
    command: Extract<OrchestrationCommand, { type: "thread.create" }>,
  ) => Promise<unknown>;
  readonly command: Extract<OrchestrationCommand, { type: "thread.create" }>;
}): Promise<void> {
  input.openChatThreadPage(input.threadId);
  await input.navigate({ to: "/$threadId", params: { threadId: input.threadId } });
  await input.dispatch(input.command);
}
